/**
 * Merge edits onto the latest Edit Supplier draft.
 *
 * Spreading the venueSupplier *prop* drops earlier edits when another field
 * is changed before React re-renders (e.g. booking-off toggle then Xero
 * mapping, or the reverse). Always merge from the previous draft state.
 *
 * @param {object|null|undefined} prev - current React state draft
 * @param {object} fallback - venueSupplier prop (used when prev is null)
 * @param {object|function} patch - fields to merge, or updater(prevBase) => patch
 */
export function mergeVenueSupplierDraft(prev, fallback, patch) {
  const base = prev || fallback || {}
  const next = typeof patch === 'function' ? patch(base) : patch
  return {
    ...base,
    ...(next || {}),
  }
}

const mappingId = value => String(value || '')

/** Confirmation after Edit Supplier saves. Mapping changes name the Xero save. */
export function supplierSaveConfirmation({ before, after } = {}) {
  const mappingChanged =
    mappingId(before?.defaultAccount) !== mappingId(after?.defaultAccount) ||
    mappingId(before?.defaultContact) !== mappingId(after?.defaultContact)
  return mappingChanged
    ? 'Supplier mapping saved'
    : 'Supplier settings updated successfully'
}
